const getters = {
    site(state) {
        return state.site
    }
};

const state = {
    site: {},
    searchByText: '',
    searchColumnOptions: [
        {value: "id", "text": "Order ID"},
        {value: "po_number", "text": "PO Number"}
    ],
    searchColumns: [],
    searchByOrderStatuses: []
};

const mutations = {
    setSite(state, site) {
        state.site = site;
    },
    setSearchByText(state, text) {
        state.searchByText = text
    },
    setSearchColumns(state, columns) {
        state.searchColumns = columns
    },
    setSearchByOrderStatuses(state, statuses) {
        state.searchByOrderStatuses = statuses
    }
};

const actions = {

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};